<template>
  <div class="position-relative">
    <button
      class="btn position-fixed btn-primary d-md-flex justify-content-center align-items-center rounded-circle w-3 h-3 z-index-scroll-to-top bottom-size position-right"
      :class="customClass"
      @click="scrollToTop"
    >
      <img
        alt="Settings icon"
        class="w-sm-1 icon-height rotate-90"
        src="@/assets/images/icons/arrow-left.svg"
        role="button"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
defineProps({
  customClass: {
    type: String,
    default: 'position-right',
  },
});

const scrollToTop = (): void => {
  window.scrollTo(0, 0);
};
</script>

<style lang="scss">
@import '@/assets/css/components/_scroll_to_top_button.scss';
</style>
